import { apiGet, apiSend } from "./client.ts";

export type CameraAccessStatus = "none" | "pending" | "active" | "blocked";

export type MyCameraAccessResponse = {
  status: CameraAccessStatus;
  ptzAllowed: boolean;
  blockedUntil: string | null;
};

/**
 * GET /api/v1/cameras/:id/me/access
 */
export async function fetchMyCameraAccess(
  cameraId: string,
): Promise<MyCameraAccessResponse> {
  return apiGet<MyCameraAccessResponse>(
    `/api/v1/cameras/${encodeURIComponent(cameraId)}/me/access`,
  );
}

export async function requestCameraAccess(cameraId: string): Promise<void> {
  await apiSend(
    `/api/v1/cameras/${encodeURIComponent(cameraId)}/access-requests`,
    "POST",
    {},
  );
}
